import { serviceCards } from './data';
import { useNavigate } from 'react-router-dom';
import { FaLongArrowAltRight } from 'react-icons/fa';
import '../assests/CSS/service.css';

function Service() {
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="home_service-container">
      <h1 className="home_service-title">Why <span style={{ color: "#113157", fontWeight: "bold" }}>Thhiya</span><span style={{ color: "red", fontSize: "1.5rem" }}>.</span>? Our Intelligent Edge.</h1>
      <div className="home_card-container">
        {serviceCards.map((cards, index) => (
          <div key={index} className="home_service-card-wrapper">
            <div className="home_service-card-inner">
              <div className="home_service-card home_front">
                <img src={cards.image} alt={cards.title} className="home_card-image" />
                <p className="home_card-title">{cards.title}</p>
                <p className="home_card-front-description">{cards.frontDescription}</p>
              </div>
              <div className="home_service-card home_back">
                <p className="home_card-description">{cards.description}</p>
                <button
                  className="home_card-button"
                  onClick={() => handleNavigation(cards.navigationPath)}
                >
                  {cards.buttonText}
                  <FaLongArrowAltRight className="home_button-arrow" />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Service;